module.exports = __webpack_public_path__ + "img/login-ico.dbbfca81.svg";